// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAuth } from "firebase/auth";
// import { GoogleAuthProvider } from "firebase/auth";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
// import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAQVcMosJmvev2KFKM6JZfr0l3OH6wNAFU",
  authDomain: "todou-247.firebaseapp.com",
  projectId: "todou-247",
  storageBucket: "todou-247.appspot.com",
  messagingSenderId: "616435330660",
  appId: "1:616435330660:web:c531fe7fd3c4f22e60f971",
  measurementId: "G-19RDR2H9M1"
};


// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// initalize components
export const auth = firebase.auth();
export const provider = new firebase.auth.GoogleAuthProvider();

export const db = firebase.firestore();

